var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDogVomit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.7 31.7",
    style: {
      enableBackground: "new 0 0 52.7 31.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C10000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    className: "st0",
    d: "M35.5,2.4c0,0-16.6-5.5-24.4,0.1c-5.9,4.2-7.3,8.1-8.2,13.1s-3.9,10-2.7,10.7s3.7-4.4,4.4-6.7 c0.4-1.3,1.6-4,2.5-6.6l2,5.6c0,0.1,0.1,0.2,0.2,0.3L6,23.5c-0.5,0.5-0.4,1.3,0,1.8l6,4.8c0.1,0.1,0.3,0.3,0.5,0.3l2.4,1.1 c0.3,0.1,0.6,0.2,0.9,0.2c1.2,0,2.2-1,2.2-2.2c0-0.2,0-0.5-0.1-0.7c-0.1-0.4-0.4-0.8-0.8-1l-2.2-1l-4-2.7l3.6-4.7 c0.2-0.2,0.3-0.5,0.3-0.7l0.3-3.8c9.3,3.1,8.8,2.1,10.4,2.4l-0.8,5.2c-0.1,0.6,0.1,1.2,0.6,1.6l4.8,4.2L30,29.5 c0,0.5,0.1,1,0.4,1.4c0.3,0.5,0.8,0.7,1.4,0.7c0.9,0,1.6-0.6,1.7-1.5l0.4-2.4c0.1-0.5-0.1-1.1-0.5-1.5l-3.8-4l2.6-5.5 c0.2-0.5,0.2-1.1-0.1-1.6c1.3-0.2,2.7-0.3,4-0.2C35.8,14.7,31,10.5,35.5,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    className: "st0",
    d: "M44.9,29.4c1.4,0,2.6-0.3,2.8-0.6c1.2-0.1,2.2-0.3,2.2-0.6s-1.1-0.6-2.4-0.7 c-0.1-0.1-0.3-0.1-0.4-0.1c-1.1-5.4-5-12.7-5-12.7l-0.4,0.1c0.9,2.9,2.2,9.8,2.8,12.6c-0.6,0.1-0.9,0.3-0.9,0.6v0.1 c-0.9,0.1-1.5,0.4-1.5,0.7C42.1,29.1,43.3,29.4,44.9,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    className: "st0",
    d: "M38.7,28.5c0,0.2,0.7,0.4,1.6,0.4s1.6-0.2,1.6-0.4s-0.7-0.4-1.6-0.4S38.7,28.3,38.7,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    className: "st0",
    d: "M52.7,28.6c0-0.2-0.5-0.3-1.1-0.3s-1.1,0.1-1.1,0.3s0.5,0.3,1.1,0.3S52.7,28.7,52.7,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    className: "st0",
    d: "M41.7,23.1c0.3,0,0.5-0.3,0.5-1.4s-0.2-3.5-0.4-3.5s-0.5,2.4-0.5,3.4S41.5,23.1,41.7,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    className: "st0",
    d: "M45.3,18.8c-0.2,0.1,0.5,1.8,0.9,2.5s0.6,0.9,0.8,0.8s0.2-0.4-0.2-1.1S45.5,18.7,45.3,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    className: "st0",
    d: "M42.7,27.4c0.4,0,0.7-0.1,0.7-0.2S43.1,27,42.7,27S42,27.1,42,27.2S42.4,27.4,42.7,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    className: "st0",
    d: "M48.4,29.4c0,0.1,0.4,0.2,0.8,0.2s0.8-0.1,0.8-0.2s-0.4-0.2-0.8-0.2S48.4,29.2,48.4,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    className: "st0",
    d: "M33.1-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    className: "st0",
    d: "M39.6,12.7l5.4,3.2l0.8,0.1c4.2-1.7,4.7-2.7,4.2-3.9s-6.1-4.3-9.2-7c-0.1-0.1-0.2-0.3-0.2-0.5 c-0.1-0.9-0.2-2.1-0.3-3.1C40-0.2,39,0.9,39,0.9l-0.5,1c-0.2,0.3-0.6,0.5-0.9,0.3l0,0c-0.3-0.1-0.6-0.1-0.8,0.1 c-1.3,1.5-2,3.3-2.1,5.3c-0.3,2.2,0.2,4.4,1.5,6.3c0.1,0.1,0.1,0.1,0.2,0.2c1.3,0.8,2.6,1.6,4,2.2c0.4,0.2,0.8,0,1-0.3 c0.1-0.2,0.1-0.5,0-0.7L39.6,12.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDogVomit);
export default __webpack_public_path__ + "static/media/icon-dog-vomit.fbc8dc288ec01b3983dff49e35840bff.svg";
export { ForwardRef as ReactComponent };